<template>
  <div class="privacy-policy-page">
    <div class="privacy-policy">
      <h2>发布日期：2025年6月19日</h2>
      <h2>生效日期：2025年6月19日</h2>
      <p>感谢您访问聚宝铺电商业务管理平台（以下称"我们"或"聚宝铺"）。本政策适用于提供聚宝铺产品和服务的厦门有条科技有限责任公司。</p>
      <p>我们非常重视用户（下称"您"）的隐私和个人信息安全保护，我们将严格按照法律法规要求，采取相应安全保护措施，尽力保护您的个人信息及隐私安全。鉴于此，我们制定本《聚宝铺隐私政策》（下称"本政策"）并提请您注意：</p>
      <p>本政策适用于我们提供的聚宝铺电商业务管理平台所提供的所有的功能和服务。请您在使用我们提供的各项功能或服务前，务必仔细阅读并透彻理解本政策，在确认充分理解并同意后再开始使用。</p>
      <p>为保障您的相关权利，本政策将向您说明聚宝铺相关产品与服务会如何收集、使用和存储您的个人信息及您享有何种权利，请您在使用聚宝铺相关产品与服务之前，阅读、了解并同意本政策。</p>
      <p>在使用聚宝铺产品服务前，请您务必仔细阅读并透彻理解本隐私政策，在确认充分理解并同意后再开始使用。我们会不时地检查并更新我们的政策，请您定期光顾本页面，以确保对最新版本隐私政策的了解。</p>
      <p>您使用或继续使用聚宝铺相关产品与服务，都表示您同意我们按照本隐私政策收集、使用、储存和分享您的信息。</p>
      <h3>本隐私政策将帮助您了解以下内容：</h3>
      <ol>
        <li>我们如何收集您的个人信息</li>
        <li>我们如何使用您的个人信息</li>
        <li>我们如何共享、披露您的个人信息</li>
        <li>我们如何存储您的个人信息</li>
        <li>我们如何保护您的个人信息</li>
        <li>您的权利</li>
        <li>我们如何处理未成年人的个人信息</li>
        <li>您的个人信息如何在全球范围转移</li>
        <li>我们如何使用Cookie和同类技术</li>
        <li>本政策的变更</li>
        <li>联系我们</li>
      </ol>

      <h3>一、我们如何收集您的个人信息</h3>
      <p>为了向您和企业用户提供服务、优化我们的服务以及保障帐号安全，聚宝铺会按照如下方式收集您在注册、使用服务时主动提供、授权或因为使用服务而产生的信息：</p>
      <ul>
        <li>当您在平台注册账号或登录现有帐户：我们将收集您的电子邮箱地址、手机号码、登陆密码、姓名、国家；</li>
        <li>当您在平台使用运单查询功能时，我们将收集您的运单号与物流跟踪信息；</li>
        <li>当您使用本平台进行产品订单配货发货时我们将收集您的店铺名称、商品信息、发货地址。我们通过您的准许后会从Shopify，Amazon，Tiktok Shop等第三方电商平台收集您所在平台买家的姓名、电话、地址与订单信息（包括：包裹信息、订单商品、价格、商品下单时间、发货时间等）；</li>
        <li>为了提供网络服务，我们将在您使用17TRACK服务时收集您的网络信息包括IP地址、Cookie；</li>
      </ul>
      <p>请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们通过页面提示，交互流程，网站公告等方式另行向你说明信息收集的内容、范围和目的，以征得您的同意。</p>

      <h3>二、我们如何使用您的个人信息</h3>
      <p>我们在向您提供服务过程中收集的数据可能会以以下方式使用：</p>
      <ul>
        <li>向您提供服务。我们会收取并存储有关您使用本网站的某些类型的信息。我们收集这些信息的目的是为了让网站更好的运作、使我们能够提供服务、正确的评估网站的运行情况；</li>
        <li>使用您的个人信息与您沟通。您可能会收到我们通过您提交的电子邮件或者手机推送的通知，例如：当您的包裹状态发生改变或者我们有新服务上线、促销等。您可以随时取消订阅；</li>
        <li>帮助我们设计新服务，改善我们现有服务；</li>
        <li>让您参与有关我们产品和服务的调查，开展与服务相关的市场活动，向您推送最新的市场活动信息及优惠方案；</li>
        <li>协助国家司法、行政、安全机关等权利机构开展调查，并遵守适用法律法规及其他向有权机构承诺之义务。</li>
      </ul>

      <h3>三、我们如何共享、披露您的个人信息</h3>
      <p>我们不会以任何情形出售、出租、交易或以其他方式向任何人披露您的个人信息，以下特殊情况下除外：</p>
      <ul>
        <li>服务提供商和供应商：为了管理、供应和改进聚宝铺的服务以及出于市场营销目的，我们可能会向服务提供商和供应商披露包括交易信息在内的个人信息。如物流公司、供应商和支付服务提供商，数据存储和管理供应商、营销和促销供应商、发送电子邮件和SMS通知的供应商。用于帮助我们改进服务、产品。</li>
        <li>保护合法权利和其他法定目的：我们可能被要求披露信息，如被传唤、法院出庭或被执法机关人员要求进行调查，或者其它任何一切由法律要求我们披露这些信息。</li>
        <li>我们还会在必要时披露个人信息，以保护我们的合法权利或执行我们的使用条款和其他协议。聚宝铺可能会根据搜查令，传票或其他合法有效的查询或命令或适用法律的其他要求提供您的个人信息。</li>
        <li>合并和/或出售资产：我们通常不会在正常经营过程中向任何第三方公司出售、交易、出租您的个人信息。但是，我们可能会收购、合并或被另一家公司收购，或者我们可能会处置部分或全部资产，在这种情况下，您的个人信息可能会被披露给另一家公司，但须遵守隐私政策有效。</li>
      </ul>

      <h3>四、我们如何存储您的个人信息</h3>
      <p>您的个人信息将被传输并存储广州腾讯云服务器中，其他个人信息将被传输并存储美国腾讯云服务器中。除非法律要求或允许更长的保留期，否则我们将在实现本隐私政策所述目的所需的最短时间内保留从您处收集的或关于您的信息。当信息不再需要用于这些目的时，我们会将其删除或以不识别您身份的形式保存。在确定此保留期时，我们会考虑各种标准，包括您请求或提供的服务类型、我们与您关系的性质、如果我们删除您的某些信息，对我们向您提供的服务的影响，以及法律要求的保留期。请注意，当您申请注销您的聚宝铺账户成功后，我们将尽快完成对您账户注销的审查。申请获得批准后，我们将完全删除的您的个人数据。如果我们停止经营产品或服务，我们将以逐一交付或公告的形式通知您，并在停止经营产品和服务后删除您的个人数据。</p>

      <h3>五、我们如何保护您的个人信息</h3>
      <p>我们采取的安全措施我们使用了行业标准的安全措施来保护您提供的个人数据免受未经授权的访问、公开披露、使用、修改、损坏或数据丢失。我们将采取以下合理可行的措施来保护您的个人数据：</p>
      <ul>
        <li>我们使用加密技术来确保数据的机密性；</li>
        <li>我们使用可信的保护机制来防止对数据的恶意攻击；</li>
        <li>我们部署了访问控制机制，以确保只有授权人员才能访问个人数据，我们举办了安全和隐私培训课程，以提高员工对保护个人数据重要性的认识；</li>
        <li>我们将使用安全加密技术在传输过程中保护您的个人数据。采取一切适当的组织、管理和技术措施，保护您在我们内部组织中提供的个人数据的安全。</li>
      </ul>
      <p>如果我们的物理、技术或管理保障措施被违反，导致未经授权访问、公开披露、更改或破坏数据，从而损害您的合法权利，我们将承担责任。在个人数据安全事件不幸发生后，我们将及时告知您法律法规的要求：安全事件的基本情况和可能产生的影响，我们已经或将要采取的处置措施，以及您可以独立预防和降低风险的建议，为您采取的补救措施等。我们将通过电子邮件、信函、电话、推送通知等方式及时通知您与事件相关的情况。</p>
      <p>虽然我们的业务旨在保护您的个人信息，但请理解，目前在任何地方都不存在100％的安全性，无论线上或线下。聚宝铺帐户需要用户名和密码才能登录。请保护好您的用户名和密码，绝不向第三方透露。</p>

      <h3>六、您的权利</h3>
      <p>根据您当地的相关法律、法规和标准以及其他国家和地区的通行做法，我们保证您对您的个人数据行使以下权利。您有权要求我们:</p>
      <ol>
        <li><b>访问您的个人信息</b><br/>您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：<br/>账户信息:如果您希望访问或编辑您的账户中的个人资料信息。<br/>您可以登陆您的聚宝铺平台账号通过：个人主页→点击右上角头像→点击「个人资料」→浏览您的昵称、手机号码、国家、邮箱；</li>
        <li><b>更正您的个人信息</b><br/>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过"1.访问您的个人信息"中罗列的方式提出更正申请。<br/>如果您无法通过上述链接更正这些个人信息，您可按照本《隐私政策》第十一章中列明的联系方式与我们联系。我们将在5-7个工作日内回复您的更正请求。</li>
        <li><b>删除您的个人信息</b><br/>在以下情形中，您可以通过发送邮件向我们提出删除个人信息的请求：
          <ul>
            <li>如果我们处理个人信息的行为违反法律法规；</li>
            <li>如果我们收集、使用您的个人信息，却未征得您的同意；</li>
            <li>如果我们处理个人信息的行为违反了与您的约定；</li>
            <li>如果您不再使用我们的产品或服务，或您注销了账号；</li>
            <li>如果我们不再为您提供产品或服务。</li>
          </ul>
          若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
        </li>
        <li><b>注销您的账户</b><br/>您随时可注销此前注册的账户。您可按照本隐私政策第十一章中列明的联系方式向我们发送账号注销申请邮件，我们将在验证您身份后的5-7个工作日内回复并进行相关操作。在注销账户之后，我们将停止为您提供产品或服务，并立即删除您的个人信息。</li>
        <li><b>获取您的个人信息副本</b><br/>您有权利获得您的个人信息副本。如您需要获取我们收集的您的个人信息副本您可按照本隐私政策第十一章中列明的联系方式与我们联系，我们将在验证您身份后的5-7个工作日内回复并进行相关操作。我们会将个人信息副本通过邮件的形式提交给您。在符合相关法律规定且技术可行的前提下，我们将会根据您的要求向您提供您的个人信息副本。</li>
        <li><b>加州居民消费者权益</b><br/>根据《加州消费者隐私法》，加州居民有权了解、访问和删除他们的个人数据。加州居民也有权选择不让企业出售他们的个人数据，也有权不因行使加州隐私权而受到歧视。我们不会出于任何目的将您的个人数据出售给任何人，也不会在回应隐私权请求时进行歧视。<br/>如果您是加州居民，请务必查看本隐私政策，了解有关您在加州隐私法下的权利以及如何根据这些权利向我们提交请求的重要信息。</li>
        <li><b>响应您的上述请求</b><br/>对于以上请求，我们将在5-7个工作日内做出答复，联系方式请见本隐私政策第十一章节。<br/>在以下情形中，我们将无法响应您的请求：
          <ul>
            <li>与个人信息控制者履行法律法规规定的义务相关的请求；</li>
            <li>与国家安全、国防安全直接相关的请求；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的请求；</li>
            <li>与犯罪侦查、起诉、审判和执行判决等直接相关的请求；</li>
            <li>个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的请求；</li>
            <li>出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的请求；</li>
            <li>响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的请求；</li>
            <li>涉及商业秘密的请求。</li>
          </ul>
        </li>
      </ol>

      <h3>七、我们如何处理未成年人的个人信息</h3>
      <ol>
        <li><b>我们期望父母或监护人指导未成年人使用我们的服务</b><br/>若您是未满14周岁的未成年人，在使用我们的产品前，应在您的父母或其他监护人监护、指导下共同阅读并同意本政策。</li>
        <li><b>我们重视保护未成年人个人信息</b><br/>我们根据相关法律法规的规定保护未成年人的个人信息，对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享或公开披露此信息。</li>
        <li><b>自查与接收反馈</b><br/>如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。同时我们建立了严格的未成年人信息收集使用规则，以保护儿童和青少年个人信息安全。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策公示的联系方式与我们联系。</li>
      </ol>

      <h3>八、您的个人信息如何在全球范围转移</h3>
      <p>我们在全球范围内对个人信息的处理与转移承诺遵守最高的隐私保护标准。当您使用我们的服务时，您的个人信息可能会被转移到位于腾讯云服务器上。此类国际转移将遵循严格的数据保护和隐私安全措施，确保与我们在您本地提供的隐私保护同等水平。</p>
      <p>对于转移到位于中国广州的腾讯云服务器上的个人信息，我们遵循中国与美国的相关隐私和数据保护法律，包括但不限于，确保有相应的安全措施存在，如加密和访问控制，以保障数据的安全与隐私。此外，我们还将监控相关的法律变动，确保我们的做法能够及时适应这些变化，维护用户的隐私权益。</p>
      <p>针对欧盟用户的个人信息，我们将依照欧盟通用数据保护条例（GDPR）的要求进行数据转移。这意味着当个人信息离开欧盟及经济区域时，我们将通过采用欧盟委员会认可的标准合同条款或在接收国有足够的数据保护水平时进行转移。我们承诺会定期评估接收国的数据保护水平，并确保保护措施的有效执行。</p>
      <p>如果您对于您的个人信息跨境转移有疑问或需要帮助，请与我们联系。</p>

      <h3>九、我们如何使用Cookie和同类技术</h3>
      <p>我们使用Cookie和其他类似技术，以提升您使用本服务的体验。当您使用本服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本服务时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务：</p>
      <ul>
        <li>加速导航</li>
        <li>追踪网站使用情况</li>
        <li>辨别用户身份、访问权限及偏好</li>
        <li>进行研究和诊断以改善我们的内容、产品和服务</li>
      </ul>
      <p>您可以通过的浏览器设置拒绝或管理cookies或数据统计工具。但请注意，如果停用cookies或数据统计工具，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</p>

      <h3>十、本政策的变更</h3>
      <p>为了确保您随时了解我们如何收集、使用和披露您的哪些信息，我们将在本网站上发布本隐私政策的任何更改或更新，并鼓励您不时查看本隐私政策。 如果我们更改本隐私政策，我们会通过修改本隐私政策顶部的日期来通知您。</p>

      <h3>十一、联系我们</h3>
      <p>如果您对本隐私政策有任何疑问，请随时与我们联系。</p>
      <p>地址：厦门市思明区观日路26号</p>
      <p>电子邮箱：xmconditionit@gmail.com</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
onMounted(() => {
  document.title = '隐私政策'
})
</script>

<style scoped>
.privacy-policy-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 16px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px #4ba3fa11;
}
.privacy-policy h2 {
  color: #2979ff;
  margin-bottom: 8px;
}
.privacy-policy h3 {
  color: #4ba3fa;
  margin-top: 24px;
  margin-bottom: 8px;
}
.privacy-policy h4 {
  color: #2979ff;
  margin-top: 16px;
  margin-bottom: 4px;
}
.privacy-policy p, .privacy-policy li {
  color: #333;
  font-size: 1rem;
  line-height: 1.8;
}
.privacy-policy ol, .privacy-policy ul {
  margin-left: 20px;
  margin-bottom: 12px;
}
</style>
